import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus-контроллер для определения мобильного устройства по ширине viewport.
 *
 * На p220 (десктопная версия): если ширина < 768px и cookie не установлен —
 * перенаправляет на p220m.
 *
 * На p220m: не делает ничего (просто маркер).
 *
 * Использование:
 *   <div data-controller="p220--mobile-redirect"
 *        data-p220--mobile-redirect-mode-value="p220">
 */
export default class extends Controller {
  static values = {
    mode: { type: String, default: "p220" } // "p220" или "p220m"
  }

  connect() {
    // Только на p220 (десктоп) проверяем необходимость редиректа
    if (this.modeValue !== "p220") return

    const preferMobileView = this._getCookie("prefer_mobile_view")

    // Если пользователь явно выбрал десктоп — не редиректим
    if (preferMobileView === "false") return

    // Если пользователь явно выбрал телефон/планшет — редиректим независимо от ширины.
    // Это важно для планшетов и внешних мониторов, где определение по viewport нестабильно.
    if (preferMobileView === "true") {
      this._redirectToMobile()
      return
    }

    // Если ширина экрана < 768px — перенаправляем на мобильную версию
    if (window.innerWidth < 768) {
      this._redirectToMobile()
    }
  }

  _redirectToMobile() {
    const mobileUrl = window.location.pathname.replace(/^\/p220\//, "/p220m/") + window.location.search
    if (mobileUrl !== window.location.pathname + window.location.search) {
      window.Turbo?.visit(mobileUrl, { action: "replace" }) || (window.location.href = mobileUrl)
    }
  }

  _getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
    return match ? match[2] : null
  }
}
